import React, { useEffect, useState } from 'react';
import Sidebar from '../Components/Sidebar';
import MobileNav from '../Components/MobileNav'; // ADD THIS
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import Loader from '../Components/Loader';

export default function Following() {
  const navigate = useNavigate();
  const isMobile = useIsMobile(); // ADD THIS
  
  const [collapsed, setCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [following, setFollowing] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      navigate('/login');
      return;
    }
    setCurrentUser(user);

    const { data: followingData, error: followingError } = await supabase
      .from('followers')
      .select('following_id')
      .eq('follower_id', user.id);

    if (followingError) {
      console.error('Following fetch error:', followingError);
      setLoading(false);
      return;
    }

    if (followingData?.length > 0) {
      const followingIds = followingData.map(f => f.following_id);
      
      const { data: usersData, error: usersError } = await supabase
        .from('igd')
        .select('user_id, avatarName, rank, clan, avatar_url')
        .in('user_id', followingIds);

      if (usersError) {
        console.error('Users fetch error:', usersError);
      } else {
        const formatted = usersData.map(user => ({
          user_id: user.user_id,
          ...user
        }));
        setFollowing(formatted);
      }
    } else {
      setFollowing([]);
    }

    setLoading(false);
  };

  const handleUnfollow = async (userId) => {
    const { error } = await supabase
      .from('followers')
      .delete()
      .eq('follower_id', currentUser.id)
      .eq('following_id', userId);

    if (!error) {
      setFollowing(following.filter(f => f.user_id !== userId));
    } else {
      console.error('Unfollow error:', error);
    }
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        background: 'var(--bg)', 
        minHeight: '100vh',
        flexDirection: isMobile ? 'column' : 'row',
      }}>
        {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}
        <div style={{ 
          flex: 1, 
          marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'), 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          padding: isMobile ? '20px' : '0',
        }}>
          <Loader size={isMobile ? 80 : 120} />
        </div>
        {isMobile && <MobileNav />}
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      background: 'var(--bg)', 
      minHeight: '100vh',
      color: 'var(--text)',
      flexDirection: isMobile ? 'column' : 'row',
    }}>
      {!isMobile && <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />}

      <div style={{ 
        flex: 1, 
        marginLeft: isMobile ? '0' : (collapsed ? '80px' : '280px'),
        padding: isMobile ? '16px' : '40px',
        paddingBottom: isMobile ? '90px' : '40px',
        transition: 'margin-left 0.3s ease',
        overflowX: 'hidden',
      }}>
        <h1 style={{ 
          fontSize: isMobile ? '24px' : '32px', 
          fontWeight: 'bold', 
          marginBottom: isMobile ? '20px' : '30px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
        }}>
          👥 Following ({following.length})
        </h1>

        {following.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: isMobile ? '40px 20px' : '60px',
            color: '#64748b'
          }}>
            <div style={{ fontSize: isMobile ? '36px' : '48px', marginBottom: '20px' }}>👥</div>
            <h3 style={{ marginBottom: '10px', fontSize: isMobile ? '16px' : '18px' }}>Not following anyone yet</h3>
            <p style={{ fontSize: isMobile ? '13px' : '14px', marginBottom: isMobile ? '20px' : '0' }}>
              Visit player profiles to follow other soldiers
            </p>
            <button
              onClick={() => navigate('/players')}
              style={{
                marginTop: '20px',
                padding: isMobile ? '14px 28px' : '12px 24px',
                background: '#38bdf8',
                border: 'none',
                borderRadius: '10px',
                color: '#000',
                fontWeight: 'bold',
                cursor: 'pointer',
                fontSize: isMobile ? '15px' : '14px',
                minHeight: '48px', // Touch target
                width: isMobile ? '100%' : 'auto',
                maxWidth: isMobile ? '250px' : 'none',
              }}
            >
              Find Players
            </button>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(280px, 1fr))',
            gap: isMobile ? '12px' : '20px'
          }}>
            {following.map(player => (
              <div
                key={player.user_id}
                style={{
                  background: 'var(--card-bg)',
                  padding: isMobile ? '16px' : '25px',
                  borderRadius: isMobile ? '12px' : '16px',
                  border: '1px solid var(--border)',
                  display: 'flex',
                  alignItems: 'center',
                  gap: isMobile ? '12px' : '15px',
                  position: 'relative',
                  minHeight: isMobile ? '80px' : 'auto',
                }}
              >
                <img
                  src={player.avatar_url || "https://i.pravatar.cc/150"}
                  alt={player.avatarName}
                  style={{
                    width: isMobile ? '50px' : '60px',
                    height: isMobile ? '50px' : '60px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid #38bdf8',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                  onClick={() => navigate(`/players/${player.user_id}`)}
                />
                
                <div style={{ 
                  flex: 1, 
                  cursor: 'pointer',
                  minWidth: 0,
                }} onClick={() => navigate(`/players/${player.user_id}`)}>
                  <h3 style={{ 
                    marginBottom: '5px', 
                    fontSize: isMobile ? '15px' : '18px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }} title={player.avatarName}>
                    {player.avatarName}
                  </h3>
                  <p style={{ color: '#64748b', fontSize: isMobile ? '12px' : '13px' }}>{player.rank}</p>
                  {player.clan && (
                    <span style={{
                      display: 'inline-block',
                      marginTop: '5px',
                      padding: isMobile ? '2px 8px' : '3px 10px',
                      background: 'rgba(139, 92, 246, 0.1)',
                      color: '#8b5cf6',
                      borderRadius: '9999px',
                      fontSize: isMobile ? '10px' : '11px',
                      fontWeight: 'bold'
                    }}>
                      {player.clan}
                    </span>
                  )}
                </div>

                <button
                  onClick={() => handleUnfollow(player.user_id)}
                  style={{
                    padding: isMobile ? '10px 14px' : '8px 16px',
                    background: 'rgba(239, 68, 68, 0.1)',
                    border: '1px solid rgba(239, 68, 68, 0.3)',
                    borderRadius: '8px',
                    color: '#ef4444',
                    fontSize: isMobile ? '12px' : '12px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    minHeight: '44px', // Touch target
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                  }}
                >
                  {isMobile ? 'Remove' : 'Unfollow'}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
      
      {isMobile && <MobileNav />}
    </div>
  );
}